// @TODO: find out how to extend the window object with JSDoc
import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import App from "./App.jsx";

const container = document.getElementById("tdg-form-renderer");

if (container) {
  const root = createRoot(container);

  const queryClient = new QueryClient();

  root.render(
    // configuration is either passed in to the script tag or as a object on window.
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>,
  );
}
